module.exports = __webpack_public_path__ + "static/img/platphom3.55e46a8d.png";